import { Button, Collapse, List } from "antd";
import React, { useState } from "react";

import {
  EditOutlined,
  InfoCircleOutlined,
  LinkOutlined,
} from "@ant-design/icons";
import { AddButton } from "~/components/buttons/AddButton.jsx";
import { config } from "~/config.js";
import { $t } from "~/i18n.js";
import { MaintenanceStatusTag } from "../../../materialTags.jsx";
import { MatDocumentModal } from "../sections/matDocumentModal.jsx";
import { OrderDeleteButtons } from "~/pages/admin/dto/components/OrderDeleteButtons.jsx";
import { getMaterialTab } from "~/redux/materiaal/materiaal.actions.js";
import { useDispatch } from "react-redux";
import { _parseDate } from "~/lib/localize.js";

export const DocumentFileList = ({
  documents,
  readOnly,
  chapter,
  allChapters,
  materialID,
  header,
  hideStatus,
  searchYear
}) => {
  const [openDocument, setOpenDocument] = useState(null);

  const dispatch = useDispatch();

  const [loadingOrder, setLoadingOrder] = useState(false);
  const save_document_order = async (documents) => {
    setLoadingOrder(true);
    // Renumber sequentially to prevent order value drift
    const normalized = documents.map((d, i) => ({ ...d, order: i }));
    const payload = {
      action: "document_order",
      documents: normalized.map((d) => {
        return { id: d.id, order: d.order, name: d.name };
      }),
    };

    try {
      const data = await dispatch(
        getMaterialTab({
          method: "POST",
          activeTab: "documents",
          materialID: materialID,
          payload,
        })
      );
      return data;
    } finally {
      setLoadingOrder(false);
    }
  };

  return (
    <>
      {openDocument && (
        <MatDocumentModal
          document={openDocument}
          closeModal={() => setOpenDocument(null)}
          readOnly={readOnly}
          allChapters={allChapters}
          materialID={materialID}
          chapter={chapter}
        />
      )}

      {header && <p className="darkgray label">{header}</p>}

      <Collapse
        size="small"
        bordered={false}
        style={{ background: "transparent", padding: "8px 0" }}
        className="documentList"
        items={documents.map((document, idx) => ({
          key: document.id,
          collapsible:
            !document.files || document.files.length === 0
              ? "disabled"
              : undefined,
          label: (
            <div className="row" style={{ gap: 8, alignItems: "center" }}>
              {!hideStatus && (
                <MaintenanceStatusTag
                  maintenance_status={document.status}
                  hideTag
                />
              )}
              {document.url && <LinkOutlined style={{ marginRight: 2 }} />}
              <span>{document.name}</span>
            </div>
          ),
          extra: (
            <div
              className="row"
              style={{ gap: 6 }}
              onClick={(e) => e.stopPropagation()}
            >
              <Button
                size="small"
                type="link"
                icon={<InfoCircleOutlined />}
                onClick={() => setOpenDocument(document)}
              />

              {!readOnly && (
                <OrderDeleteButtons
                  loading={loadingOrder}
                  task_index={idx}
                  task={document}
                  tasks={documents}
                  saveTasks={(d) => save_document_order(d)}
                  hasDelete={false}
                />
              )}

              {!readOnly && (
                <Button
                  icon={<EditOutlined />}
                  size="small"
                  shape="circle"
                  onClick={() => setOpenDocument(document)}
                />
              )}
            </div>
          ),
          children: (
            <List
              size="small"
              dataSource={searchYear ? document.files?.filter((file) => {
                return file.date_created.startsWith(searchYear) || file.alias.indexOf(searchYear) > -1 || file.version.indexOf(searchYear) > -1
              }) : document.files || []}
              renderItem={(file) => (
                <List.Item
                  extra={
                    <div className="row" style={{ gap: 8 }}>
                      {file.version && <p className="gray" >𝘃{file.version}</p>}
                      <p className="gray" style={{marginRight: 30}}>
                      {_parseDate(file.date_created)}
                    </p>
                    </div>
                  }
                >
                  <div className="row" style={{ gap: 8, alignItems: "center" }}>
                    <a
                      title="file"
                      href={
                        file.file ? config.media_prefix + file.file : file.url
                      }
                      target="_blank"
                    >
                      {file.url && <LinkOutlined style={{ marginRight: 4 }} />}
                      {file.alias
                        ? file.alias
                        : file.file
                        ? file.file.split("___").pop()
                        : file.url.substr(0, 60)}
                    </a>
                  </div>
                </List.Item>
              )}
            />
          ),
        }))}
      />

      {!readOnly && (
        <AddButton
          style={{ marginBottom: 6, marginLeft: 6 }}
          size="small"
          onClick={() =>
            setOpenDocument({
              chapter_id: chapter.id,
              order:
                chapter.documents?.length > 0
                  ? chapter.documents?.length + 1
                  : 1,
              name: "",
              files: [],
            })
          }
        />
      )}
    </>
  );
};
